import {
  Button,
  FormLabel,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Stack,
} from '@chakra-ui/react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiSearch } from 'react-icons/fi';
import { MdOutlineClear } from 'react-icons/md';

export function GlobalFilter(props: {
  globalFilterPlaceholder: string;
  autoFocus?: boolean;
  setFocusInput?: Dispatch<SetStateAction<boolean>>;
  searchString?: string;
  inputOnChange: (value: string) => void;
  setSearchString: Dispatch<SetStateAction<string | undefined>>;
}) {
  const { globalFilterPlaceholder, autoFocus, setFocusInput, searchString, setSearchString, inputOnChange } = props;
  return (
    <HStack justifyContent="space-between" w={'full'}>
      <InputGroup size="sm">
        <InputLeftElement pointerEvents="none">
          <Icon as={FiSearch} color="muted" boxSize="5" />
        </InputLeftElement>
        <Input
          autoFocus={autoFocus}
          value={searchString ?? ''}
          data-test-id="search-table"
          onClick={() => {
            if (setFocusInput) {
              setFocusInput(true);
            }
          }}
          onChange={(e) => {
            //setA(e.target.value);
            setSearchString(e.target.value);
            inputOnChange(e.target.value);
          }}
          placeholder={globalFilterPlaceholder}
        />
      </InputGroup>
    </HStack>
  );
}

// Component for Default Column Filter
// @ts-ignore
export function DefaultFilterForColumn({ column: { filterValue, setFilter } }) {
  return (
    <Input
      value={filterValue || ''}
      onChange={(e) => {
        // Set undefined to remove the filter entirely
        setFilter(e.target.value || undefined);
      }}
      style={{ marginTop: '10px' }}
    />
  );
}

export type DropdownOption = {
  value: any;
  label: string;
};

// Component for Custom Select Filter

export function SelectColumnFilter({
  // @ts-ignore
  filterValue,
  // @ts-ignore
  column: { setFilter, id, Header },
  // @ts-ignore
  dropdownOptions,
  // @ts-ignore
  onChange,
  margin = 5,
}) {
  const selectId = `filter-${id}-dropdown`;
  return (
    <Stack direction={'column'} width={'300px'} mt={margin}>
      <FormLabel size="lg" htmlFor={selectId} pl="1" mb={0}>
        {Header}
      </FormLabel>
      <Select
        aria-label={'filter'}
        value={filterValue ?? ''}
        id={selectId}
        onChange={(e) => {
          setFilter(e.target.value || undefined);
          onChange(e.target.value || undefined);
        }}
      >
        {dropdownOptions.map((option: DropdownOption, index: number) => {
          return (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </Select>
    </Stack>
  );
}

export function InputDropDown(props: {
  filteredValue: string | undefined;
  dropdownOptions: Array<DropdownOption>;
  column: { Header: string };
  onChange: Dispatch<SetStateAction<string>>;
}) {
  const {
    filteredValue,
    dropdownOptions,
    column: { Header },
    onChange,
  } = props;

  const { t } = useTranslation();
  const [dropdownOptionName, setDropdownOptionName] = useState('');
  const [dropdownOptionId, setDropdownOptionId] = useState('');
  const [inputValue, setInputValue] = useState('');

  const filteredDropdownOptions = dropdownOptions.filter((value: any) => value.label.toLowerCase().startsWith(inputValue.toLowerCase()));
  const inputElement = document.getElementById('input-dropdown-input-field');

  useEffect(() => {
    setTimeout(() => {
      inputElement?.focus();
    }, 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);

  return (
    <Stack direction={'column'} width={'300px'} mt={5}>
      <FormLabel size="lg" pl="1" mb={0}>
        {Header}
      </FormLabel>

      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <Icon as={FiSearch} color="muted" boxSize="5" />
        </InputLeftElement>

        <Input
          defaultValue={inputValue}
          id={'input-dropdown-input-field'}
          onClick={() => {
            onChange('');
          }}
          //shows filtered value, initial value or input text
          value={dropdownOptionName ? dropdownOptionName : filteredValue ? filteredValue : inputValue}
          onChange={(e) => {
            const inputText = e.target.value;
            setInputValue(inputText);
          }}
          placeholder={t('forms:fullname.label')}
        />
        <InputRightElement>
          <Button
            borderRadius={6}
            sx={{
              _hover: {
                bg: 'red.200',
                color: 'green',
              },
            }}
            variant="ghost"
            onClick={() => {
              onChange('');
              setInputValue('');
              setDropdownOptionName('');
            }}
          >
            <Icon as={MdOutlineClear} color="red.500" boxSize="5" />
          </Button>
        </InputRightElement>
      </InputGroup>

      {inputValue.length > 0 && filteredDropdownOptions.length > 0 && (
        <Menu isOpen={!dropdownOptionId}>
          <MenuButton as={Button} style={{ height: 0 }} />
          <MenuList mt={-1}>
            {filteredDropdownOptions.map((option: DropdownOption) => (
              <MenuItem
                key={option.label}
                onClick={() => {
                  const optionId = option.value;
                  //resets filter if no id is there, e.g. if you select all
                  if (optionId == '') {
                    onChange('');
                  }
                  setDropdownOptionId(optionId);
                  onChange(optionId || undefined);
                }}
              >
                {option.label}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      )}
    </Stack>
  );
}
